import sideAddLicenses from './sideAddLicenses.vue'
export default sideAddLicenses
